var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 411.356,
    height: 222.894,
    viewBox: "0 0 411.356 222.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3462",
    "data-name": "Group 3462",
    transform: "translate(-2207.524 -264.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3624",
    "data-name": "Group 3624",
    transform: "translate(2310.667 270.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3601",
    "data-name": "Group 3601",
    transform: "translate(47.516 20.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6544",
    "data-name": "Path 6544",
    d: "M2847.437,644.22c-.294-2.682-.535-5.371-.65-8.067a46.762,46.762,0,0,1-.329-6.014h-.516s-1.343.075-1.283,1.057c.2,3.269,1.179,18.672,1.525,23.832a1.156,1.156,0,0,0,.234.625,8.56,8.56,0,0,0,1.637,1.808c.15.024.3.036.453.052C2848.372,653.061,2847.923,648.657,2847.437,644.22Z",
    transform: "translate(-2754.522 -520.22)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3593",
    "data-name": "Group 3593",
    transform: "translate(68.436 134.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6545",
    "data-name": "Path 6545",
    d: "M2853.444,699.94H2794.53a2.786,2.786,0,0,1-2.045-.9l-3.684-4.748a1.045,1.045,0,0,1-.172-1.133,1.058,1.058,0,0,1,.983-.643h22.07a.387.387,0,0,1,0,.773h-22.07a.3.3,0,0,0-.221.5l3.683,4.748a2,2,0,0,0,1.456.623h58.914a.314.314,0,0,0,.243-.514l-5.624-4.958-.03-.028a1.162,1.162,0,0,0-.854-.375H2828.1a.387.387,0,1,1,0-.773h19.075a1.939,1.939,0,0,1,1.409.609l5.627,4.962.03.029a1.087,1.087,0,0,1-.8,1.823Z",
    transform: "translate(-2788.534 -692.518)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3594",
    "data-name": "Group 3594",
    transform: "translate(68.363 134.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6546",
    "data-name": "Path 6546",
    d: "M2789.461,694.959c-.075.025-.257,2.881.148,3.322l3.663,4.723a2.392,2.392,0,0,0,1.762.773h58.914c.61,0,.677-1.309.744-3.1Z",
    transform: "translate(-2788.964 -694.572)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6547",
    "data-name": "Path 6547",
    d: "M2853.327,703.55h-58.914a2.784,2.784,0,0,1-2.046-.9l-3.685-4.748c-.54-.585-.288-3.4-.23-3.625a.45.45,0,0,1,.265-.3.386.386,0,0,1,.478.519,9.031,9.031,0,0,0,.084,2.916l3.677,4.74a2,2,0,0,0,1.457.623h58.914c.262-.165.322-1.773.357-2.732a.387.387,0,0,1,.773.028C2854.383,702.092,2854.328,703.55,2853.327,703.55Zm-64.363-8.839h0Zm0,0h0Zm.1-.05a.388.388,0,0,1-.1.049A.385.385,0,0,0,2789.063,694.661Z",
    transform: "translate(-2788.343 -693.958)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6548",
    "data-name": "Path 6548",
    d: "M2854.577,698.992l-5.641-4.975a1.548,1.548,0,0,0-1.139-.5h-57.568a.688.688,0,0,0-.506,1.153l.39,3.059,4.334,3.508,59.778.29C2854.835,701.528,2854.99,699.441,2854.577,698.992Z",
    transform: "translate(-2720.714 -559.097)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6549",
    "data-name": "Path 6549",
    d: "M2860.957,657.193l-5.39.018-6.905.023a8.864,8.864,0,0,1-1.441-.106,8.568,8.568,0,0,1-1.637-1.808,1.157,1.157,0,0,1-.234-.625c-.345-5.16-1.325-20.563-1.525-23.832-.06-.982,1.283-1.057,1.283-1.057l14.089.017a.676.676,0,0,1,.684.624c.1,1.49,1.814,24.005,1.781,26.01A.7.7,0,0,1,2860.957,657.193Z",
    transform: "translate(-2754.011 -520.015)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3595",
    "data-name": "Group 3595",
    transform: "translate(89.747 109.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6550",
    "data-name": "Path 6550",
    d: "M2845.805,655.427a.387.387,0,0,1-.309-.153,1.542,1.542,0,0,1-.312-.833c-.346-5.159-1.32-20.473-1.524-23.834a1.2,1.2,0,0,1,.3-.89,2.126,2.126,0,0,1,1.349-.577l14.112.017a1.067,1.067,0,0,1,1.069.985c.019.277.093,1.277.2,2.736.428,5.763,1.318,17.753,1.534,21.964a.386.386,0,0,1-.366.406.4.4,0,0,1-.406-.367c-.215-4.2-1.1-16.186-1.532-21.945-.108-1.462-.183-2.464-.2-2.741a.289.289,0,0,0-.3-.264l-14.089-.018c-.016,0-.933.066-.9.648.206,3.36,1.179,18.671,1.525,23.83a.771.771,0,0,0,.155.416.387.387,0,0,1-.306.621Z",
    transform: "translate(-2843.657 -629.14)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3596",
    "data-name": "Group 3596",
    transform: "translate(91.667 109.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6551",
    "data-name": "Path 6551",
    d: "M2850.5,654.64a.386.386,0,0,1-.385-.361c-.159-2.345-.476-7.437-.781-12.362-.318-5.109-.618-9.935-.708-11.154a1.141,1.141,0,0,1,.407-.94.387.387,0,0,1,.49.6.369.369,0,0,0-.126.285c.091,1.224.391,6.052.709,11.163.306,4.923.623,10.015.781,12.358a.387.387,0,0,1-.36.412Z",
    transform: "translate(-2848.624 -629.735)",
    fill: "#6a7099"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6552",
    "data-name": "Path 6552",
    d: "M2794.661,460.34H2627.3a7.349,7.349,0,0,1-7.325-6.751c-4.22-51.654-4.7-59.178-7.432-95.343-.8-10.616,13.365-11.429,13.365-11.429l161.405.187a7.349,7.349,0,0,1,7.325,6.75c1.322,16.108,7.345,76.961,7.345,98.638A7.349,7.349,0,0,1,2794.661,460.34Z",
    transform: "translate(-2612.126 -346.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3597",
    "data-name": "Group 3597",
    transform: "translate(91.323 134.796)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6553",
    "data-name": "Path 6553",
    d: "M2851.342,697.425a9.23,9.23,0,0,1-1.461-.111c-.521-.083-1.729-1.564-2.1-2.256a.387.387,0,0,1,.681-.367,7,7,0,0,0,1.576,1.866,9.874,9.874,0,0,0,1.344.1l6.905-.023c1.692-.006,4.869-.042,6.037-.142a.381.381,0,0,1,.418.352.386.386,0,0,1-.352.418c-1.194.1-4.4.139-6.1.145l-6.905.023Zm-1.29-.861Z",
    transform: "translate(-2847.733 -694.487)",
    fill: "#6a7099"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6554",
    "data-name": "Path 6554",
    d: "M2638.733,616.71c.451,5.129,1.824,8.688,4.653,8.688h167.359c2.861,0,7.661-1.7,7.449-9.494Z",
    transform: "translate(-2628.21 -511.489)",
    fill: "#fad3b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    d: "M2613.116,365.835h182.589c-.46-5.092-.834-9.269-1.065-12.081a7.349,7.349,0,0,0-7.325-6.75l-161.405-.187s-14.167.814-13.365,11.429C2612.747,360.924,2612.936,363.441,2613.116,365.835Z",
    transform: "translate(-2612.126 -346.43)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6556",
    "data-name": "Path 6556",
    d: "M2627.19,459.4c-3.659-3.005-2.931-8.306-3.275-12.554-.864-10.661-1.756-21.269-2.233-31.958-.489-10.951-1.475-22.577-2.609-33.474-.5-4.82-.9-10.238-1.16-15.077-.216-4-.513-6.738.823-10.55.807-2.3,2.471-6.166,4.835-8.14-3.987.757-11.621,3.237-11.027,11.11,2.729,36.165,3.212,43.689,7.432,95.343a7.349,7.349,0,0,0,7.325,6.751h2.186A11.43,11.43,0,0,1,2627.19,459.4Z",
    transform: "translate(-2612.126 -346.938)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3598",
    "data-name": "Group 3598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6557",
    "data-name": "Path 6557",
    d: "M2794.048,460.115H2626.689a7.779,7.779,0,0,1-7.71-7.107c-3.428-41.967-4.376-54.6-6.095-77.539-.393-5.248-.826-11.023-1.338-17.806a9.139,9.139,0,0,1,2.189-6.966c3.842-4.388,11.228-4.861,11.54-4.879L2786.7,346a7.779,7.779,0,0,1,7.71,7.106c.275,3.351.744,8.544,1.34,15.118,2.246,24.823,6.006,66.37,6.006,83.552a7.734,7.734,0,0,1-7.711,8.334ZM2625.3,346.59c-.05,0-7.356.474-10.981,4.617a8.4,8.4,0,0,0-2,6.4c.512,6.783.945,12.559,1.338,17.807,1.719,22.935,2.666,35.57,6.094,77.534a7,7,0,0,0,6.94,6.4h167.358a6.963,6.963,0,0,0,6.94-7.53c0-17.178-3.76-58.7-6-83.514-.595-6.575-1.065-11.769-1.34-15.124a7,7,0,0,0-6.939-6.4Z",
    transform: "translate(-2611.513 -345.818)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3599",
    "data-name": "Group 3599",
    transform: "translate(4.445 1.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6558",
    "data-name": "Path 6558",
    d: "M2638.093,462.517a7.78,7.78,0,0,1-7.71-7.107c-2.268-27.774-3.576-46.924-4.627-62.311-.929-13.608-1.664-24.355-2.718-36.325a8.511,8.511,0,0,1,2.848-6.949.387.387,0,0,1,.5.591,7.717,7.717,0,0,0-2.577,6.29c1.055,11.977,1.789,22.728,2.719,36.34,1.051,15.385,2.359,34.532,4.626,62.3a7,7,0,0,0,6.939,6.4.387.387,0,1,1,0,.773Z",
    transform: "translate(-2623.01 -349.735)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6559",
    "data-name": "Path 6559",
    d: "M2853.881,704.892a1.782,1.782,0,0,0,.276-1.478.786.786,0,0,0-1.164-.668c-.341.175-52.45.013-55.264.288h-.007c-.155-.011-2.969-.109-4.015-.2-.021,0-.038,0-.058,0-.035-.036-.072-.07-.1-.106a.877.877,0,0,0-.058-.082c-.568-.656-1.129-1.314-1.659-2-.46-.611-.89-1.244-1.3-1.9l-.116-.433a.774.774,0,0,0-1.49.411l.02.074a.723.723,0,0,0,.1.5l.076.172c.032.121.065.242.1.362a.708.708,0,0,0,.5.5c.017.027.034.054.052.081a.886.886,0,0,0,.059.112,24.443,24.443,0,0,0,3.458,4.131c.054.051.418.553.476.586-.072.429,18.08.239,19.212.287,3.137.171,13.1-.013,14.94-.174,0,0,11.6-.076,12.557-.039.035.008,11.921.234,12.775-.044.051-.016.089-.038.134-.056A.657.657,0,0,0,2853.881,704.892Z",
    transform: "translate(-2720.317 -561.71)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3600",
    "data-name": "Group 3600",
    transform: "translate(69.058 135.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6560",
    "data-name": "Path 6560",
    d: "M2854.43,702.663h-58.914a2.788,2.788,0,0,1-2.046-.9l-3.248-4.185a.386.386,0,0,1,.611-.474l3.226,4.16a2.007,2.007,0,0,0,1.458.623h58.914a.387.387,0,1,1,0,.773Z",
    transform: "translate(-2790.141 -696.956)",
    fill: "#6a7099"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3606",
    "data-name": "Group 3606",
    transform: "translate(77.939 173.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3602",
    "data-name": "Group 3602"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6561",
    "data-name": "Path 6561",
    d: "M2862.583,765.625a1.211,1.211,0,0,1-1.21,1.206l-153.282.033a6.2,6.2,0,0,1-3.022-.544c-.867-.553-10.742-14.546-13.459-18.92-.481-.774-.388-4.169-.388-4.169a.851.851,0,0,1,.09-.457,1.272,1.272,0,0,1,1.156-.632l149.355.329a3.527,3.527,0,0,1,2.682,1.146s15.825,16.628,17.839,19.472A7.452,7.452,0,0,1,2862.583,765.625Z",
    transform: "translate(-2690.826 -741.755)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6562",
    "data-name": "Path 6562",
    d: "M2707.243,766.636a6.023,6.023,0,0,1-3-.6c-.983-.627-11.057-14.982-13.578-19.042-.511-.822-.464-3.735-.447-4.364a1.246,1.246,0,0,1,.132-.639,1.658,1.658,0,0,1,1.5-.846h0l149.356.33a3.917,3.917,0,0,1,2.976,1.283c.632.664,15.852,16.664,17.86,19.5.1.138.326.461.309,2.762a1.6,1.6,0,0,1-1.6,1.59l-153.376.033Zm-15.395-24.722a.9.9,0,0,0-.808.419.476.476,0,0,0-.051.251.251.251,0,0,1,0,.043,12.831,12.831,0,0,0,.33,3.955c2.891,4.655,12.491,18.184,13.342,18.8a5.665,5.665,0,0,0,2.713.481h.1l153.282-.033a.83.83,0,0,0,.824-.822l.386,0-.386,0a6.512,6.512,0,0,0-.17-2.313c-1.973-2.785-17.643-19.258-17.8-19.424a3.148,3.148,0,0,0-2.4-1.026l-149.356-.33Z",
    transform: "translate(-2690.209 -741.141)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6563",
    "data-name": "Path 6563",
    d: "M2862.583,765.625a1.211,1.211,0,0,1-1.21,1.206l-153.282.033c-.551,0-2.169.121-3.022-.544-1.959-1.524-10.742-14.546-13.459-18.92-.481-.774-.388-4.169-.388-4.169a.851.851,0,0,1,.09-.457,1.272,1.272,0,0,1,1.156-.632l149.355.329a3.527,3.527,0,0,1,2.682,1.146s15.825,16.628,17.839,19.472A7.452,7.452,0,0,1,2862.583,765.625Z",
    transform: "translate(-2690.826 -741.755)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3603",
    "data-name": "Group 3603",
    transform: "translate(1.386 1.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6564",
    "data-name": "Path 6564",
    d: "M2841.581,765.609c-2.042,0-3.842,0-5.182-.005l-123.4-.4c-.35,0-.765.012-1.206.025-.76.023-1.619.048-2.177.011-2.541-.173-4.213-2.62-5.557-4.587l-.067-.1c-2.483-3.631-10.195-14.964-10.195-14.964l.639-.435s7.713,11.331,10.194,14.962l.067.1c1.314,1.924,2.8,4.1,4.971,4.251.52.036,1.361.01,2.1-.012.451-.013.867-.026,1.2-.025l123.437.4c2.8.008,7.62.006,12.438,0s9.637-.006,12.44,0a.387.387,0,0,1,0,.773h0c-2.8-.009-7.62-.005-12.438,0C2846.323,765.608,2843.809,765.609,2841.581,765.609Z",
    transform: "translate(-2693.795 -745.156)",
    fill: "#6a7099"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3604",
    "data-name": "Group 3604",
    transform: "translate(8.534 2.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6565",
    "data-name": "Path 6565",
    d: "M2865.7,763.955h-.005l-141.876-.581a3.556,3.556,0,0,1-2.885-1.5l-8.372-11.848a1.487,1.487,0,0,1,1.214-2.346h0l138.8.387a3.834,3.834,0,0,1,2.821,1.254l11.279,12.424a1.323,1.323,0,0,1-.979,2.212Zm-151.924-15.5a.714.714,0,0,0-.582,1.126h0l8.372,11.849a2.781,2.781,0,0,0,2.256,1.174l141.876.581h0a.549.549,0,0,0,.407-.919l-11.28-12.424a3.059,3.059,0,0,0-2.25-1l-138.8-.387Z",
    transform: "translate(-2712.284 -747.678)",
    fill: "#6a7099"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3605",
    "data-name": "Group 3605",
    transform: "translate(110.48 4.387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6566",
    "data-name": "Path 6566",
    d: "M2986.763,764.653a.385.385,0,0,1-.285-.126l-10.393-11.392a.387.387,0,1,1,.571-.521l10.393,11.392a.386.386,0,0,1-.285.647Z",
    transform: "translate(-2975.983 -752.488)",
    fill: "#6a7099"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3616",
    "data-name": "Group 3616",
    transform: "translate(145.931 8.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3607",
    "data-name": "Group 3607"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6567",
    "data-name": "Path 6567",
    d: "M3020.439,418.016H2883.248a8.384,8.384,0,0,1-8.2-7.543c-4.027-32.022-2.2-26.424-7.93-85.1a8.123,8.123,0,0,1,8.114-8.88H3012.42a8.452,8.452,0,0,1,8.2,7.542c2.536,17.447,7.147,70.519,7.931,85.1A8.151,8.151,0,0,1,3020.439,418.016Z",
    transform: "translate(-2866.69 -316.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6568",
    "data-name": "Path 6568",
    d: "M3019.827,417.789h-137.19a8.721,8.721,0,0,1-8.587-7.881c-2.135-16.979-2.637-23.535-3.468-34.4-.748-9.764-1.771-23.137-4.463-50.715a8.459,8.459,0,0,1,2.155-6.495,8.58,8.58,0,0,1,6.345-2.809h137.191a8.849,8.849,0,0,1,8.584,7.874c2.544,17.494,7.159,70.694,7.935,85.138a8.539,8.539,0,0,1-8.5,9.287ZM2874.618,316.264a7.806,7.806,0,0,0-5.772,2.555,7.586,7.586,0,0,0-1.957,5.9c2.693,27.587,3.717,40.964,4.465,50.732.831,10.85,1.331,17.4,3.464,34.36a7.957,7.957,0,0,0,7.82,7.2h137.19a7.665,7.665,0,0,0,5.714-2.511,7.822,7.822,0,0,0,2.016-5.949c-.775-14.446-5.387-67.6-7.928-85.081a8.084,8.084,0,0,0-7.82-7.211Z",
    transform: "translate(-2866.079 -315.491)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6569",
    "data-name": "Path 6569",
    d: "M3105.358,391.982c-.239.029-.48.04-.713.047q-4.1.118-8.206.014a1.743,1.743,0,0,1-2.008-2.034l-.685-6.107c-.221-1.971.092-3.308,2.318-3.33l8.318-.083a1.679,1.679,0,0,1,2.048,1.915q.367,3.366.734,6.733a2.84,2.84,0,0,1-.373,2.208A2.161,2.161,0,0,1,3105.358,391.982Z",
    transform: "translate(-3005.693 -355.36)",
    fill: "#deeaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6570",
    "data-name": "Path 6570",
    d: "M3041.218,391.982c-.238.029-.48.04-.713.047q-4.1.118-8.206.014a1.742,1.742,0,0,1-2.006-2.034q-.343-3.054-.686-6.107c-.221-1.971.093-3.308,2.319-3.33l8.318-.083a1.679,1.679,0,0,1,2.048,1.915l.734,6.733a2.848,2.848,0,0,1-.374,2.208A2.161,2.161,0,0,1,3041.218,391.982Z",
    transform: "translate(-2966.35 -355.36)",
    fill: "#deeaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6571",
    "data-name": "Path 6571",
    d: "M3170.37,391.982c-.238.029-.479.04-.712.047q-4.105.118-8.207.014a1.744,1.744,0,0,1-2.007-2.034q-.342-3.054-.685-6.107c-.221-1.971.092-3.308,2.318-3.33l8.318-.083a1.679,1.679,0,0,1,2.048,1.915q.367,3.366.734,6.733a2.844,2.844,0,0,1-.374,2.208A2.157,2.157,0,0,1,3170.37,391.982Z",
    transform: "translate(-3045.573 -355.36)",
    fill: "#deeaf7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3608",
    "data-name": "Group 3608",
    transform: "translate(90.325 21.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6572",
    "data-name": "Path 6572",
    d: "M3104.99,383.208a1.613,1.613,0,0,1-1.169-.5l-3.887-4.03a.773.773,0,0,1,1.114-1.074l3.886,4.031a.07.07,0,0,0,.07.025.071.071,0,0,0,.058-.038c1.622-2.836,6.126-10.87,6.171-10.951a.773.773,0,1,1,1.348.756c-.044.081-4.553,8.121-6.178,10.963a1.609,1.609,0,0,1-1.209.805A1.662,1.662,0,0,1,3104.99,383.208Z",
    transform: "translate(-3099.718 -370.275)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6573",
    "data-name": "Path 6573",
    d: "M3110.309,440.995c-.238.029-.479.04-.712.047q-4.105.118-8.206.014a1.743,1.743,0,0,1-2.007-2.035l-.686-6.107c-.221-1.97.093-3.308,2.318-3.33l8.318-.083a1.679,1.679,0,0,1,2.048,1.915q.368,3.366.734,6.733a2.84,2.84,0,0,1-.374,2.208A2.159,2.159,0,0,1,3110.309,440.995Z",
    transform: "translate(-3008.731 -385.425)",
    fill: "#deeaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6574",
    "data-name": "Path 6574",
    d: "M3046.17,440.995c-.238.029-.479.04-.712.047q-4.1.118-8.206.014a1.744,1.744,0,0,1-2.007-2.035q-.343-3.054-.685-6.107c-.221-1.97.092-3.308,2.318-3.33l8.318-.083a1.678,1.678,0,0,1,2.048,1.915q.367,3.366.734,6.733a2.845,2.845,0,0,1-.373,2.208A2.16,2.16,0,0,1,3046.17,440.995Z",
    transform: "translate(-2969.388 -385.425)",
    fill: "#deeaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6575",
    "data-name": "Path 6575",
    d: "M3175.322,440.995c-.237.029-.479.04-.712.047q-4.106.118-8.206.014a1.744,1.744,0,0,1-2.007-2.035q-.344-3.054-.686-6.107c-.22-1.97.093-3.308,2.318-3.33l8.318-.083a1.678,1.678,0,0,1,2.048,1.915q.368,3.366.735,6.733a2.843,2.843,0,0,1-.374,2.208A2.158,2.158,0,0,1,3175.322,440.995Z",
    transform: "translate(-3048.609 -385.425)",
    fill: "#deeaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6576",
    "data-name": "Path 6576",
    d: "M3115.463,490.917c-.238.029-.479.04-.712.047q-4.105.118-8.206.014a1.744,1.744,0,0,1-2.008-2.035q-.342-3.053-.685-6.107c-.221-1.971.092-3.308,2.318-3.33l8.318-.083a1.679,1.679,0,0,1,2.048,1.915l.735,6.733a2.846,2.846,0,0,1-.374,2.208A2.161,2.161,0,0,1,3115.463,490.917Z",
    transform: "translate(-3011.893 -416.047)",
    fill: "#deeaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6577",
    "data-name": "Path 6577",
    d: "M3051.323,490.917c-.238.029-.479.04-.711.047q-4.106.118-8.207.014a1.743,1.743,0,0,1-2.007-2.035q-.342-3.053-.685-6.107c-.221-1.971.094-3.308,2.318-3.33l8.318-.083a1.679,1.679,0,0,1,2.048,1.915l.734,6.733a2.844,2.844,0,0,1-.373,2.208A2.162,2.162,0,0,1,3051.323,490.917Z",
    transform: "translate(-2972.549 -416.047)",
    fill: "#deeaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6578",
    "data-name": "Path 6578",
    d: "M3180.476,490.917c-.238.029-.48.04-.712.047q-4.1.118-8.207.014a1.743,1.743,0,0,1-2.007-2.035q-.344-3.053-.686-6.107c-.221-1.971.093-3.308,2.318-3.33l8.317-.083a1.679,1.679,0,0,1,2.048,1.915l.735,6.733a2.844,2.844,0,0,1-.374,2.208A2.161,2.161,0,0,1,3180.476,490.917Z",
    transform: "translate(-3051.771 -416.047)",
    fill: "#deeaf7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3609",
    "data-name": "Group 3609",
    transform: "translate(66.689 40.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6579",
    "data-name": "Path 6579",
    d: "M3043.85,434.343a1.617,1.617,0,0,1-1.168-.5l-3.886-4.031a.773.773,0,1,1,1.113-1.074l3.886,4.031a.073.073,0,0,0,.07.025.074.074,0,0,0,.058-.039c1.621-2.835,6.126-10.87,6.172-10.95a.773.773,0,0,1,1.348.756c-.045.081-4.553,8.121-6.178,10.963a1.612,1.612,0,0,1-1.209.805A1.665,1.665,0,0,1,3043.85,434.343Z",
    transform: "translate(-3038.579 -421.411)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7006",
    "data-name": "Path 7006",
    d: "M3043.85,434.343a1.617,1.617,0,0,1-1.168-.5l-3.886-4.031a.773.773,0,1,1,1.113-1.074l3.886,4.031a.073.073,0,0,0,.07.025.074.074,0,0,0,.058-.039c1.621-2.835,6.126-10.87,6.172-10.95a.773.773,0,0,1,1.348.756c-.045.081-4.553,8.121-6.178,10.963a1.612,1.612,0,0,1-1.209.805A1.665,1.665,0,0,1,3043.85,434.343Z",
    transform: "translate(-2986.351 -403.632)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3610",
    "data-name": "Group 3610",
    transform: "translate(22.739 29.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6580",
    "data-name": "Path 6580",
    d: "M2952.08,394.6H2925.67a.773.773,0,1,1,0-1.546h26.411a.773.773,0,1,1,0,1.546Z",
    transform: "translate(-2924.896 -393.054)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3611",
    "data-name": "Group 3611",
    transform: "translate(62.707 15.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6581",
    "data-name": "Path 6581",
    d: "M3039.132,357.008h-10.08a.773.773,0,1,1,0-1.546h10.08a.773.773,0,1,1,0,1.546Z",
    transform: "translate(-3028.279 -355.462)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3612",
    "data-name": "Group 3612",
    transform: "translate(88.14 15.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6582",
    "data-name": "Path 6582",
    d: "M3104.92,357.008h-10.08a.773.773,0,1,1,0-1.546h10.08a.773.773,0,1,1,0,1.546Z",
    transform: "translate(-3094.067 -355.462)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3613",
    "data-name": "Group 3613",
    transform: "translate(112.715 15.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6583",
    "data-name": "Path 6583",
    d: "M3168.485,357.008H3158.4a.773.773,0,0,1,0-1.546h10.081a.773.773,0,0,1,0,1.546Z",
    transform: "translate(-3157.632 -355.462)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3614",
    "data-name": "Group 3614",
    transform: "translate(24.653 49.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6584",
    "data-name": "Path 6584",
    d: "M2957.032,445.938h-26.412a.773.773,0,0,1,0-1.546h26.412a.773.773,0,1,1,0,1.546Z",
    transform: "translate(-2929.848 -444.392)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3615",
    "data-name": "Group 3615",
    transform: "translate(27.505 69.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6585",
    "data-name": "Path 6585",
    d: "M2964.409,497.275H2938a.773.773,0,0,1,0-1.546h26.411a.773.773,0,1,1,0,1.546Z",
    transform: "translate(-2937.225 -495.729)",
    fill: "#211d52"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3618",
    "data-name": "Group 3618",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3617",
    "data-name": "Group 3617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6586",
    "data-name": "Path 6586",
    d: "M2622.99,387.7H2504.5a7.724,7.724,0,0,1-7.557-6.95c-3.71-29.5-2.027-24.346-7.306-78.409a7.484,7.484,0,0,1,7.476-8.182H2615.6a7.787,7.787,0,0,1,7.558,6.949c2.336,16.074,6.585,64.972,7.307,78.409A7.51,7.51,0,0,1,2622.99,387.7Z",
    transform: "translate(-2489.219 -293.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6587",
    "data-name": "Path 6587",
    d: "M2622.378,387.473H2503.893a8.066,8.066,0,0,1-7.941-7.288c-1.968-15.645-2.43-21.686-3.2-31.694-.688-9-1.631-21.317-4.113-46.725a7.827,7.827,0,0,1,1.993-6.007,7.935,7.935,0,0,1,5.869-2.6H2614.99a8.184,8.184,0,0,1,7.94,7.28c2.344,16.125,6.6,65.14,7.311,78.444a7.9,7.9,0,0,1-7.863,8.589ZM2496.5,293.933a7.161,7.161,0,0,0-5.3,2.344,6.964,6.964,0,0,0-1.8,5.412c2.483,25.417,3.426,37.742,4.115,46.742.765,10,1.227,16.03,3.192,31.656a7.3,7.3,0,0,0,7.174,6.611h118.485a7.032,7.032,0,0,0,5.242-2.3,7.172,7.172,0,0,0,1.849-5.457c-.713-13.306-4.962-62.279-7.3-78.388a7.418,7.418,0,0,0-7.176-6.618Z",
    transform: "translate(-2488.607 -293.16)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6588",
    "data-name": "Path 6588",
    d: "M2629.026,341.92h-96.759a3.128,3.128,0,0,1-3.267-2.407c-.569-4.356-1.1-8.181-1.442-12.042-.183-2.066,1.236-2.832,3.109-2.832h96.759a3.153,3.153,0,0,1,3.267,2.405c.481,3.169,1.027,7.393,1.442,12.044C2632.334,340.614,2630.9,341.92,2629.026,341.92Z",
    transform: "translate(-2512.49 -312.469)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6589",
    "data-name": "Path 6589",
    d: "M2552.39,337.122a4.168,4.168,0,0,1-4.262,4.6,4.8,4.8,0,0,1-4.649-4.6,4.458,4.458,0,1,1,8.911,0Z",
    transform: "translate(-2522.265 -317.302)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6590",
    "data-name": "Path 6590",
    d: "M2633.943,395.786h-96.76a3.187,3.187,0,0,1-3.267-2.407c-.948-5.334-.675-6.691-1.441-12.042-.219-1.524,1.237-2.832,3.109-2.832h96.76a3.155,3.155,0,0,1,3.267,2.406c.48,3.169,1.026,7.393,1.442,12.044C2637.25,394.479,2635.816,395.786,2633.943,395.786Z",
    transform: "translate(-2515.502 -345.51)",
    fill: "#fad3b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6591",
    "data-name": "Path 6591",
    d: "M2557.316,390.987a4.169,4.169,0,0,1-4.262,4.6,4.8,4.8,0,0,1-4.649-4.6,4.458,4.458,0,1,1,8.911,0Z",
    transform: "translate(-2525.286 -350.343)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6592",
    "data-name": "Path 6592",
    d: "M2639.235,449.651h-96.759a3.187,3.187,0,0,1-3.267-2.407c-.947-5.334-.675-6.691-1.441-12.042-.219-1.524,1.237-2.832,3.109-2.832h96.76a3.154,3.154,0,0,1,3.266,2.405c.481,3.169,1.026,7.393,1.442,12.044C2642.542,448.345,2641.108,449.651,2639.235,449.651Z",
    transform: "translate(-2518.749 -378.551)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6593",
    "data-name": "Path 6593",
    d: "M2562.608,444.852a4.169,4.169,0,0,1-4.262,4.6,4.8,4.8,0,0,1-4.649-4.6,4.458,4.458,0,1,1,8.911,0Z",
    transform: "translate(-2528.533 -383.384)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3623",
    "data-name": "Group 3623",
    transform: "translate(34.801 106.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3619",
    "data-name": "Group 3619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6594",
    "data-name": "Path 6594",
    d: "M2669.023,601.586h-83.952a3.905,3.905,0,0,1-3.7-3.667c-.949-8.126-.99-16.193-1.729-24.345a3.843,3.843,0,0,1,3.661-4.314h83.952a3.869,3.869,0,0,1,3.7,3.665c.469,4.827,1.376,17.262,1.729,24.347A3.855,3.855,0,0,1,2669.023,601.586Z",
    transform: "translate(-2579.237 -568.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6595",
    "data-name": "Path 6595",
    d: "M2668.409,601.359h-83.952a4.264,4.264,0,0,1-4.083-4.009c-.539-4.611-.79-9.278-1.032-13.792-.186-3.458-.378-7.033-.7-10.564a4.48,4.48,0,0,1,1.131-3.424,3.919,3.919,0,0,1,2.915-1.311h83.952a4.251,4.251,0,0,1,4.083,4.014c.468,4.82,1.377,17.258,1.731,24.366a4.533,4.533,0,0,1-1.159,3.431A3.9,3.9,0,0,1,2668.409,601.359Zm-85.721-32.326a3.153,3.153,0,0,0-2.344,1.06,3.7,3.7,0,0,0-.93,2.833c.321,3.545.513,7.127.7,10.591.243,4.5.492,9.156,1.028,13.743a3.5,3.5,0,0,0,3.316,3.326h83.952a3.133,3.133,0,0,0,2.318-1.04,3.765,3.765,0,0,0,.956-2.856c-.354-7.11-1.261-19.53-1.728-24.341a3.485,3.485,0,0,0-3.315-3.315Z",
    transform: "translate(-2578.624 -568.26)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6596",
    "data-name": "Path 6596",
    d: "M2630.031,594.643c.042,4.386-2.692,8.773-8.325,8.773a8.879,8.879,0,0,1-8.654-8.773,8.714,8.714,0,0,1,8.654-8.773C2627.173,585.87,2629.99,590.256,2630.031,594.643Z",
    transform: "translate(-2599.742 -579.062)",
    fill: "#ffd56b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6597",
    "data-name": "Path 6597",
    d: "M2641.731,599.8a.875.875,0,0,0,0,1.749A.875.875,0,0,0,2641.731,599.8Z",
    transform: "translate(-2616.816 -587.605)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6598",
    "data-name": "Path 6598",
    d: "M2626.085,599.7a.875.875,0,0,0,0,1.749A.875.875,0,0,0,2626.085,599.7Z",
    transform: "translate(-2607.219 -587.547)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3620",
    "data-name": "Group 3620",
    transform: "translate(19.573 15.486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6599",
    "data-name": "Path 6599",
    d: "M2631.855,610.6a2.962,2.962,0,0,1-2.553-1.6.386.386,0,1,1,.678-.37,2.164,2.164,0,0,0,2,1.192,1.8,1.8,0,0,0,1.567-1.253.387.387,0,0,1,.723.276,2.581,2.581,0,0,1-2.239,1.748Q2631.94,610.595,2631.855,610.6Z",
    transform: "translate(-2629.254 -608.316)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6600",
    "data-name": "Path 6600",
    d: "M2692.238,594.643c.042,4.386-2.692,8.773-8.325,8.773a8.879,8.879,0,0,1-8.654-8.773,8.714,8.714,0,0,1,8.654-8.773C2689.379,585.87,2692.2,590.256,2692.238,594.643Z",
    transform: "translate(-2637.9 -579.062)",
    fill: "#deeaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6601",
    "data-name": "Path 6601",
    d: "M2703.937,599.8a.875.875,0,0,0,0,1.749A.875.875,0,0,0,2703.937,599.8Z",
    transform: "translate(-2654.973 -587.605)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6602",
    "data-name": "Path 6602",
    d: "M2688.291,599.7a.875.875,0,0,0,0,1.749A.875.875,0,0,0,2688.291,599.7Z",
    transform: "translate(-2645.376 -587.547)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3621",
    "data-name": "Group 3621",
    transform: "translate(43.622 15.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6603",
    "data-name": "Path 6603",
    d: "M2695.927,609.406h0l-4.081-.038a.387.387,0,0,1,0-.773h0l4.081.038a.387.387,0,0,1,0,.773Z",
    transform: "translate(-2691.459 -608.595)",
    fill: "#211d52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6604",
    "data-name": "Path 6604",
    d: "M2754.444,594.643c.041,4.386-2.692,8.773-8.326,8.773a8.878,8.878,0,0,1-8.654-8.773,8.714,8.714,0,0,1,8.653-8.773C2751.585,585.87,2754.4,590.256,2754.444,594.643Z",
    transform: "translate(-2676.057 -579.062)",
    fill: "#628ad9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6605",
    "data-name": "Path 6605",
    d: "M2766.142,599.8a.875.875,0,0,0,0,1.749A.875.875,0,0,0,2766.142,599.8Z",
    transform: "translate(-2693.13 -587.605)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6606",
    "data-name": "Path 6606",
    d: "M2750.5,599.7a.875.875,0,0,0,0,1.749A.875.875,0,0,0,2750.5,599.7Z",
    transform: "translate(-2683.532 -587.547)",
    fill: "#211d52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3622",
    "data-name": "Group 3622",
    transform: "translate(67.646 15.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6607",
    "data-name": "Path 6607",
    d: "M2758.252,610.555a.386.386,0,0,1-.346-.214,2.15,2.15,0,0,0-1.953-1.26,1.8,1.8,0,0,0-1.61,1.2.386.386,0,0,1-.712-.3,2.58,2.58,0,0,1,2.3-1.67A2.959,2.959,0,0,1,2758.6,610a.387.387,0,0,1-.345.56Z",
    transform: "translate(-2753.601 -608.308)",
    fill: "#211d52"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3708",
    "data-name": "Group 3708",
    transform: "translate(2207.524 264.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6960",
    "data-name": "Path 6960",
    d: "M849.219,318.29s2.989-3.211,6.323-1.965c4.824,1.8,25.228,11.267,20.162,33.137-5.337,23.038-21.911,17.148-21.911,17.148s-19.968,1.128-19.953-21.116S845.18,316.576,849.219,318.29Z",
    transform: "translate(-818.09 -315.167)",
    fill: "#23110d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6961",
    "data-name": "Path 6961",
    d: "M795.314,365.009s3.647-1.6,5.5-2.188c1.3-.413-.376-1.516-2.534-.784-1.117.379-5.53,2.525-5.53,2.525Z",
    transform: "translate(-698.127 -311.116)",
    fill: "#ca8873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6963",
    "data-name": "Path 6963",
    d: "M797.45,363.667c.109-.217,2.162-3.021,3.945-3.482s-3.242,5.535-3.242,5.535l-4.107.594Z",
    transform: "translate(-700.043 -311.26)",
    fill: "#ca8873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6964",
    "data-name": "Path 6964",
    d: "M808.634,363.675a10.851,10.851,0,0,1,2.325-1.922c1.351-.808.214-2.993-.7-2.076s-6.213,2.546-6.538,3.518S808.634,363.675,808.634,363.675Z",
    transform: "translate(-720.358 -311.322)",
    fill: "#ca8873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6965",
    "data-name": "Path 6965",
    d: "M800.026,367.254l6.813-2.142a50.68,50.68,0,0,1,2.148-5.321c.517-.707-1.836-.757-2.447.7s-1.345,3.736-1.345,3.736l-9.351,1.944Z",
    transform: "translate(-709.281 -311.335)",
    fill: "#ca8873"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6966",
    "data-name": "Path 6966",
    d: "M798.789,366.256s-.37-5.159,5.449-3.431c1.536.456,3.082.883,4.64,1.255a6.161,6.161,0,0,0,2.689.281,22.8,22.8,0,0,1-1.14-4.368,1.834,1.834,0,0,1,1.493-2.267q.624,3.011,1.25,6.025a3.263,3.263,0,0,1-.008,1.989c-.6,1.344-2.387,1.64-3.606,2.121a13.13,13.13,0,0,1-5,1.114C801.555,368.971,798.789,366.256,798.789,366.256Z",
    transform: "translate(-716.748 -311.476)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6967",
    "data-name": "Path 6967",
    d: "M828.511,359.529s.9-1.9,2.855.35,13.815,19.3,13.815,19.3,1.657,11.612-4.168,4.934C836.029,378.4,828.511,359.529,828.511,359.529Z",
    transform: "translate(-781.18 -311.382)",
    fill: "#6b8ba7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6968",
    "data-name": "Path 6968",
    d: "M842.815,358.706c.256-.013.512-.027.764-.037l.295-.015,0,.005c4.55-.172,8.649.173,11.357.194.386,2.161,2.124,3.9,4.109,5.2.3.427.6.852.918,1.286,2.685,3.691,4.259,6.123,2.532,10.806-1.7,4.608.147,8.68,1.872,12.943a108.408,108.408,0,0,0-21.627-.728c.181-3.968-1.891-7.983-2.679-11.828-.71-3.467-1.623-7.044-2.419-10.629A18.541,18.541,0,0,0,842.815,358.706Z",
    transform: "translate(-810.709 -311.397)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6969",
    "data-name": "Path 6969",
    d: "M842.993,387.742c.181-3.968-1.891-7.983-2.679-11.828-.689-3.367-1.589-6.838-2.375-10.319h22.905c2.288,3.227,3.491,5.63,1.9,9.933-1.7,4.608.147,8.68,1.872,12.943A108.4,108.4,0,0,0,842.993,387.742Z",
    transform: "translate(-810.665 -310.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6970",
    "data-name": "Path 6970",
    d: "M853.719,411.392s6.992,20.583-1.368,48.34c0,0-3.713,32.327-.4,56.216.176,1.273-3.884.053-3.884.053s-15.185-43.763-6.77-55.094l-8.395-42.84Z",
    transform: "translate(-797.014 -306.723)",
    fill: "#d78c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6971",
    "data-name": "Path 6971",
    d: "M867.47,413.761a241.6,241.6,0,0,1-9.856,51.653s1.257,5.7-10.14,49.13l-3.515-4.674s-3.635-39.295,3.587-47.51c0,0-6.75-41.352-3.413-51.709S867.47,413.761,867.47,413.761Z",
    transform: "translate(-819.08 -307.136)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6972",
    "data-name": "Path 6972",
    d: "M834.206,460.843c.779-17.006-9.218-41.025-3.125-59.134,2.825-8.394,7.976-10.617,8.455-12.7a11.336,11.336,0,0,0,.151-2.867c1.335,0,2.659-.007,3.958.009,5.668.068,11.356.046,17.018-.243,1.319-.066,2.638-.159,3.955-.258l.811,3.431c1.385,2.3,5.632,11.806,6.687,22.949.97,10.243-3.431,35.907-6.431,47.777,0,0-5.6,2.208-16.159,2.208A83.158,83.158,0,0,1,834.206,460.843Z",
    transform: "translate(-808.678 -309.003)",
    fill: "#6b8ba7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3706",
    "data-name": "Group 3706",
    transform: "translate(20.424 76.645)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6973",
    "data-name": "Path 6973",
    d: "M834.687,401.708c2.825-8.394,7.976-10.617,8.455-12.7a11.336,11.336,0,0,0,.151-2.867c1.335,0,2.659-.007,3.958.009,5.668.068,11.356.046,17.018-.243,1.319-.066,2.638-.159,3.955-.258l.811,3.431a43.062,43.062,0,0,1,2.9,6.539,56.651,56.651,0,0,0-7.673-.513c-8.314-.257-16.656.862-20.116,9.477-3.483,8.676-2.024,19.827-1.456,28.861.6,9.554,1.819,18.94-.131,28.06-3.071-.315-4.744-.66-4.744-.66C838.592,443.837,828.595,419.818,834.687,401.708Z",
    transform: "translate(-832.709 -385.648)",
    fill: "#202131"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6974",
    "data-name": "Path 6974",
    d: "M835.718,500.824l8.531,17.165,4.379-.036-1.714,1.893H836.556l-4.976-8.327,2.539,8.327h-2.437l-5.17-12.937,3.749-9.769Z",
    transform: "translate(-782.233 -299.13)",
    fill: "#d78c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6975",
    "data-name": "Path 6975",
    d: "M829.139,500.048c6.809,17.837,15.11,17.685,15.11,17.685l4.379-.036-1.713,1.893H836.557l-4.976-8.327,2.538,8.327h-2.437l-5.171-12.936Z",
    transform: "translate(-782.234 -298.873)",
    fill: "#1a304c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6976",
    "data-name": "Path 6976",
    d: "M863.335,500.311l4.861,21.462H855.543l2.608-21.788Z",
    transform: "translate(-833.403 -298.878)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6977",
    "data-name": "Path 6977",
    d: "M863.335,500.3l4.861,21.462H855.543l2.621-21.606-.235,16.943,6.245.257Z",
    transform: "translate(-833.403 -298.864)",
    fill: "#1a304c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6978",
    "data-name": "Path 6978",
    d: "M834,359.424c1.1-.183,6-.8,8.534-.926,3.453,6.591,7.457,13.2,10.905,20.1,0-6.581-.389-13.4-.389-19.979.231,0,4.157.505,4.157.505a84.43,84.43,0,0,1,6.094,10.905c2.385,5.279-.719,8.644-.719,8.644l5.009,12.388s-1.559,2.013-5.323,2.013c-1.883,0-7.856-1.623-7.856-1.623a11.907,11.907,0,0,1-8.437,2.272,28.727,28.727,0,0,1-7.984-2.077,19.67,19.67,0,0,0,1.038-4.8C839.59,379.585,834,359.424,834,359.424Z",
    transform: "translate(-809.344 -311.407)",
    fill: "#6b8ba7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3707",
    "data-name": "Group 3707",
    transform: "translate(25.663 51.844)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6979",
    "data-name": "Path 6979",
    d: "M837.118,362.865a31.452,31.452,0,0,0,8.569,7.941,18.019,18.019,0,0,0,7.365,2.621c.851,1.583,1.692,3.175,2.5,4.786,0-1.513-.024-3.039-.056-4.571a51.726,51.726,0,0,0,10.756-1.035,7.631,7.631,0,0,1-1.355,5.423c-.057,0-.112.01-.169.011a19.341,19.341,0,0,0-13.609,4.072c-3.838,2.982-6.171,6.289-7.051,10.462a23.833,23.833,0,0,1-3.966-1.315,19.675,19.675,0,0,0,1.038-4.8C841.547,381.177,838.7,369.072,837.118,362.865Z",
    transform: "translate(-837.118 -362.865)",
    fill: "#202131"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6980",
    "data-name": "Path 6980",
    d: "M888.977,359.468l.593,3.171s-13.105,10.451-19.642,15.672c-1.262,1.271-6.265,1.091-5.7-.889C866.445,369.715,888.977,359.468,888.977,359.468Z",
    transform: "translate(-864.187 -311.321)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6981",
    "data-name": "Path 6981",
    d: "M866.721,375.366s9.708.158,22.509,9.759l-1.338,2.677s-16.2-2.855-24.511-10.715Z",
    transform: "translate(-862.969 -309.914)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6982",
    "data-name": "Path 6982",
    d: "M888.884,359.278a28.322,28.322,0,0,0,.747,3.748s-13.852,10.113-20.389,15.333c-1.262,1.271-6.265,1.091-5.7-.889C865.759,369.763,888.884,356.579,888.884,359.278Z",
    transform: "translate(-863.501 -311.37)",
    fill: "#6b8ba7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6983",
    "data-name": "Path 6983",
    d: "M886.1,379.88a9.586,9.586,0,0,0-1.532,3.138,34.073,34.073,0,0,1-9.148-5.859l4.6-2.61s2.445.992,8.139,3.2A18.367,18.367,0,0,0,886.1,379.88Z",
    transform: "translate(-875.009 -309.986)",
    fill: "#6b8ba7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6984",
    "data-name": "Path 6984",
    d: "M857.685,384h1.954s8.254,6.022,7.962,6.754-1.367,1.18-1.416,1.62.44,1.639-.489,1.884-1.758.136-1.807.673-.049,1.118-.978,1.216a6.611,6.611,0,0,1-1.563,0s-.195-.257-.537.041-.977.152-1.857.347-1.638.618-1.856,0a15.851,15.851,0,0,0-.808-2.361c-.577-1,.984-1.18,1.771-.1,0,0-1.476-3.005-1.463-4.08a5.494,5.494,0,1,0,0-.65Z",
    transform: "translate(-833.492 -309.149)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6985",
    "data-name": "Path 6985",
    d: "M882.3,377.978s-3.334,1.854-4,5.139l-3.685-1.259a8.237,8.237,0,0,1,4.609-5.907Z",
    transform: "translate(-868.268 -309.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6986",
    "data-name": "Path 6986",
    d: "M843.827,358.615l.389,19.979s4.056-6.871,3.376-13.416-1.906-6.346-1.906-6.346A3.044,3.044,0,0,0,843.827,358.615Z",
    transform: "translate(-800.123 -311.401)",
    fill: "#6b8ba7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6987",
    "data-name": "Path 6987",
    d: "M849.794,358.666s-.766-.469-2.8.061A29.835,29.835,0,0,0,860.722,378.6S851.157,360.022,849.794,358.666Z",
    transform: "translate(-816.629 -311.409)",
    fill: "#6b8ba7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6988",
    "data-name": "Path 6988",
    d: "M832.136,364.747s-23.019,14.078-22.5,18.319,3.992,3.376,10.132-2.381,14.189-13.913,14.189-13.913Z",
    transform: "translate(-749.185 -310.854)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6989",
    "data-name": "Path 6989",
    d: "M831.637,375.754a9.076,9.076,0,0,0,.624,6.894c.066.14.141.28.213.419-3.618,2.506-5.69,2.219-6.081-.975C826.227,380.73,828.49,378.352,831.637,375.754Z",
    transform: "translate(-765.942 -309.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6990",
    "data-name": "Path 6990",
    d: "M849.705,361l-.334-6.911a3.339,3.339,0,1,1,6.629-.33l.313,6.888Z",
    transform: "translate(-814.797 -312.141)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6991",
    "data-name": "Path 6991",
    d: "M849.654,357.357l-.158-3.27a3.339,3.339,0,1,1,6.629-.33l.177,3.908A14.9,14.9,0,0,1,849.654,357.357Z",
    transform: "translate(-814.922 -312.141)",
    fill: "#d78c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6992",
    "data-name": "Path 6992",
    d: "M852.615,319.093a16.426,16.426,0,0,1,5.377.3,18.14,18.14,0,0,1,9.762,6.193,19.559,19.559,0,0,1,1.964,2.778l.078.134c4.982,8.657,4.1,22.71-5.193,28.226a14.6,14.6,0,0,1-6.583,2.076c-9.185.581-17.875-7.847-19.32-17.043C837.211,332.272,841.928,320.235,852.615,319.093Z",
    transform: "translate(-819.38 -314.905)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6993",
    "data-name": "Path 6993",
    d: "M852.617,319.093a16.426,16.426,0,0,1,5.377.3,18.141,18.141,0,0,1,9.762,6.193,19.563,19.563,0,0,1,1.964,2.778l.078.134a24.507,24.507,0,0,1,2.065,18.454,10.524,10.524,0,0,0-2.685-5.764c-7.161-5.669-14.341-5.421-18.2-12.543-1.928,6.464-10.017,11.784-12.272,13.112C837.213,332.272,841.931,320.235,852.617,319.093Z",
    transform: "translate(-819.382 -314.905)",
    fill: "#c78575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6994",
    "data-name": "Path 6994",
    d: "M869.771,339.91c.062.39-.087-.388,0,0Z",
    transform: "translate(-850.451 -313.063)",
    fill: "#c78575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6995",
    "data-name": "Path 6995",
    d: "M846.757,345.828l11.4-.92a.945.945,0,0,1,.971,1.24c-1,2.971-3.327,5.143-6.173,5.373s-5.489-1.542-6.955-4.315A.944.944,0,0,1,846.757,345.828Z",
    transform: "translate(-813.871 -312.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6996",
    "data-name": "Path 6996",
    d: "M844.136,336.5c1.2-.382,2.593.669,3.123,2.349s-.011,3.353-1.206,3.735-2.594-.668-3.123-2.348S842.94,336.879,844.136,336.5Z",
    transform: "translate(-798.718 -313.363)",
    fill: "#381911"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6997",
    "data-name": "Path 6997",
    d: "M845.93,337.58a4.32,4.32,0,0,1,.568,1.161c.529,1.681-.011,3.353-1.206,3.735a2.386,2.386,0,0,1-2.566-1.2Q844.32,339.421,845.93,337.58Z",
    transform: "translate(-797.957 -313.26)",
    fill: "#fff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6998",
    "data-name": "Path 6998",
    d: "M859.668,337.5c1.207-.386,2.62.676,3.155,2.373s-.011,3.385-1.218,3.772-2.619-.675-3.154-2.372S858.461,337.891,859.668,337.5Z",
    transform: "translate(-831.177 -313.273)",
    fill: "#381911"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6999",
    "data-name": "Path 6999",
    d: "M861.479,338.48a4.233,4.233,0,0,1,.678,1.3c.535,1.7-.011,3.385-1.218,3.772a2.478,2.478,0,0,1-2.694-1.385Q859.9,340.356,861.479,338.48Z",
    transform: "translate(-830.512 -313.18)",
    fill: "#fff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7000",
    "data-name": "Path 7000",
    d: "M845.673,317.4s4.685-2.98,8.12-1.939c7.155,2.173,27.12,11.205,22.142,33.932-1.583,7.229-5.027,10.5-7.912,13.231,3.74-5.11,3.579-11.859,1.982-17.513-3.184-12.712-18.242-6.875-21.917-19.237-1.841,9.449-9.469,9.338-13.635,17.589-1.013,2.008-1.291,4.8-1.6,6.9a33.212,33.212,0,0,1-.475-5.632C832.3,321.6,839.744,316.269,845.673,317.4Zm18.247,17.254c-2.877-3.617-8.654-3.947-10.978-8.273C853.472,331.54,860.489,331.744,863.92,334.651Z",
    transform: "translate(-816.708 -315.238)",
    fill: "#381911"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7001",
    "data-name": "Path 7001",
    d: "M853.781,333.765c-2.843-1.054-5.609-2.25-7.614-4.67.591-.147,1.177-.308,1.753-.484.668-.2,1.319-.43,1.956-.674,1.7,2.054,4.988,2.9,7.648,4.205C856.3,332.731,855.05,333.276,853.781,333.765Z",
    transform: "translate(-812.525 -314.113)",
    fill: "#fff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7002",
    "data-name": "Path 7002",
    d: "M847.917,330.854c-1.077.606-2.174,1.189-3.289,1.736-2.24-1.64-5.139-2.54-7.285-4.314a19.567,19.567,0,0,0,9.675-8.029,31.214,31.214,0,0,1,6.725,6.176A19.325,19.325,0,0,1,847.917,330.854Z",
    transform: "translate(-799.141 -314.794)",
    fill: "#fff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7003",
    "data-name": "Path 7003",
    d: "M867.6,335.659a31.827,31.827,0,0,1-7.07-2.2q.309-2.492.77-4.569a29.014,29.014,0,0,0,4.293.914,32.343,32.343,0,0,0,8.089-.013C872.064,332.26,869.828,333.813,867.6,335.659Z",
    transform: "translate(-844.324 -314.029)",
    fill: "#fff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7004",
    "data-name": "Path 7004",
    d: "M867.921,339.1c1.584-.71,3.682.53,4.687,2.77s.537,4.633-1.047,5.344-3.682-.53-4.688-2.77S866.338,339.814,867.921,339.1Z",
    transform: "translate(-850.104 -313.142)",
    fill: "#e5a185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7005",
    "data-name": "Path 7005",
    d: "M850.991,344.86a3.845,3.845,0,0,0,1.523-1c2.623,5.183,7.314,9.957,12.785,11.4a16.289,16.289,0,0,0,8.986-.175,14.408,14.408,0,0,1-5.547,1.516c-6.755.428-13.238-4.02-16.772-10.06a2.275,2.275,0,0,1-.409.245c-1.562.7-3.622-.5-4.643-2.679A4.2,4.2,0,0,0,850.991,344.86Z",
    transform: "translate(-830.098 -312.704)",
    fill: "#d78c74"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7007",
    "data-name": "Path 7007",
    d: "M3043.85,434.343a1.617,1.617,0,0,1-1.168-.5l-3.886-4.031a.773.773,0,1,1,1.113-1.074l3.886,4.031a.073.073,0,0,0,.07.025.074.074,0,0,0,.058-.039c1.621-2.835,6.126-10.87,6.172-10.95a.773.773,0,0,1,1.348.756c-.045.081-4.553,8.121-6.178,10.963a1.612,1.612,0,0,1-1.209.805A1.665,1.665,0,0,1,3043.85,434.343Z",
    transform: "translate(-705.311 -120.185)",
    fill: "#211d52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepOne);
export default __webpack_public_path__ + "static/media/stepOne.324f8b2964b98fc803a53f02ff03b250.svg";
export { ForwardRef as ReactComponent };